/*
 * 엔진 명령어(`/`) — 어느 작품에서나 쓰는 연출 지시. 작품이 정하는 `!` 명령어(속마음 · 스냅 · 기록창)와 따로 간다.
 * 보내면 일반 턴과 같은 요금으로 한 턴이 되고, 서버는 directive 를 그 턴의 연출 지시로 프롬프트에 넣는다(backend.md §6-9).
 * 뒤에 붙인 말(arg)은 선택 — 비우면 엔진이 지금 흐름에 맞춰 정한다.
 */

export type EngineCommand = {
  /** `/` 뒤 이름 */
  key: string
  /** 목록 한 줄 설명 */
  desc: string
  /** 이름 뒤에 덧붙일 말의 예 — 입력창 안내로 보인다 */
  hint: string
}

export const ENGINE_COMMANDS: EngineCommand[] = [
  {
    key: '점프',
    desc: '다음 장면으로 이동',
    hint: '예: 다음 날 아침, 축제 당일',
  },
  { key: '사건', desc: '돌발사건 발생', hint: '예: 정전, 낯선 사람의 등장' },
  { key: '시간', desc: '시간을 흐르게 하기', hint: '예: 3시간 뒤, 해 질 무렵' },
  { key: '장소', desc: '다른 곳으로 옮기기', hint: '예: 옥상, 비 오는 정류장' },
  { key: '등장', desc: '새 인물 불러오기', hint: '예: 소꿉친구, 담임 선생님' },
  { key: '회상', desc: '지난 기억 꺼내기', hint: '예: 처음 만난 날' },
  { key: '묘사', desc: '지금 장면을 자세히', hint: '예: 표정, 방 안 풍경' },
]

export type Directive = { key: string; arg?: string }

/** `/점프 다음 날` → { key: '점프', arg: '다음 날' }. 엔진 명령어가 아니면 null */
export function parseDirective(text: string): Directive | null {
  const match = /^\/(\S+)(?:\s+([\s\S]*))?$/.exec(text.trim())
  if (!match) return null
  const command = ENGINE_COMMANDS.find((c) => c.key === match[1])
  if (!command) return null
  const arg = match[2]?.trim()
  return arg ? { key: command.key, arg } : { key: command.key }
}

export function findEngineCommand(key: string) {
  return ENGINE_COMMANDS.find((c) => c.key === key)
}
